const ACCOUNT_NAMES = {
  '440835327940': 'VeevaServices',
  '555096501589': 'VeevaIT',
  '265706493823': 'VeevaWebDev',
  '435196505416': 'VeevaWebProd',
  '623398264659': 'VeevaWebQA',
};

/**
 * Returns "Name (account_id)" if the account has a known name,
 * otherwise returns the account ID as-is.
 */
export function accountLabel(id) {
  if (!id) return '';
  const name = ACCOUNT_NAMES[id];
  return name ? `${name} (${id})` : id;
}

export default ACCOUNT_NAMES;
